'use client'

import { getPreferredTranslation } from 'src/_helpers/getPreferredTranslation'
import { getDomainJournalNavTree } from './domainJournalLinks'
import { useTranslateEntry } from 'src/i18n/client/useTranslateEntry'
import DomainJournalTopbar from './DomainJournalTopbar'
import DomainJournalContent from './DomainJournalContent'
import useJournalDomainRoutes from './useJournalDomainRoutes'

export default function DomainJournalHeader({ journal, newestIssue, newestVolume, locale }) {
  const translation = getPreferredTranslation(journal, locale) || {}
  const title = translation.title || journal.title
  const translate = useTranslateEntry()
  const journalRoutes = useJournalDomainRoutes()
  const navLinks = getDomainJournalNavTree(journal, locale, translate, journalRoutes)
  const primaryColor = journal.primaryColor || journal.mainColor || journal.color || '#ec8944'

  return (
    <header style={{ '--journal-primary': primaryColor }}>
      <DomainJournalTopbar
        journal={journal}
        title={title}
        navLinks={navLinks}
        primaryColor={primaryColor}
        locale={locale}
      />
      <DomainJournalContent
        journal={journal}
        newestIssue={newestIssue}
        newestVolume={newestVolume}
        title={title}
        translation={translation}
        locale={locale}
      />
    </header>
  )
}
